import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.grayDark2};

  & > header {
    margin-bottom: 1rem;

    & > h2 {
      font-weight: bold;
      font-size: 1.5rem;
      margin: 0;
    }

    & > span {
      font-style: italic;
    }
  }
`;
export const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const NotificationItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 85%;
    padding: 1.5rem 0;
  }
`;
